import { FC } from 'react'

import clsx from 'clsx'

import DangerTriangleIcon from 'shared/icons/payment-method/danger-triangle.svg'
import InfoTriangleIcon from 'shared/icons/payment-method/info-triangle.svg'

import s from './styles.module.scss'

interface Props {
  variant?: 'info' | 'danger'
  title: string
  description?: string
  actionText?: string
  onAction?: () => void
}

export const StatusNotice: FC<Props> = ({
  variant = 'info',
  title,
  description,
  actionText,
  onAction,
}) => {
  return (
    <div className={clsx(s.container, s[variant])}>
      <div className={s.iconWrapper}>
        <img
          src={variant === 'danger' ? DangerTriangleIcon : InfoTriangleIcon}
          alt=""
          className={s.icon}
        />
      </div>

      <div className={clsx(s.text, 'bold-12')}>
        <p>{title}</p>

        {description && <p>{description}</p>}
      </div>

      {actionText && (
        <div className={s.action}>
          <button
            type="button"
            className={clsx(s.button, 'medium-12')}
            onClick={onAction}
          >
            {actionText}
          </button>
        </div>
      )}
    </div>
  )
}
